import PropTypes from 'prop-types';
import { URLS } from '@/constants/urls';
import styles from './Tag.module.scss';

export const Tag = ({
	children,
	displayClose = false,
	onClose,
	isSmall = false,
	clickable = false,
	hoverable = true,
	isActive = false,
	hasBorderRadius = true,
	customClassName = '',
	isActiveWithBackground = false,
}) => {
	const tagStyle = [
		styles.container,
		clickable ? styles.pointer : '',
		isSmall ? styles.small : '',
		hoverable ? '' : styles['no-hover'],
		isActive ? styles.active : '',
		isActive && isActiveWithBackground ? styles['active-with-background'] : '',
		hasBorderRadius ? '' : styles['no-border-radius'],
		customClassName,
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className={tagStyle} onClick={onClose} data-test-id="tag" data-rbf="tag">
			<span className={styles.children}>{children}</span>

			{displayClose && (
				<span className={styles.icon}>
					<img src={URLS.ORION_CLOSE_BLACK} data-test-id="icon-close" alt="close" />
				</span>
			)}
		</div>
	);
};

Tag.propTypes = {
	children: PropTypes.node.isRequired,
	displayClose: PropTypes.bool,
	onClose: PropTypes.func,
	isSmall: PropTypes.bool,
	clickable: PropTypes.bool,
	hoverable: PropTypes.bool,
	isActive: PropTypes.bool,
	isActiveWithBackground: PropTypes.bool,
	hasBorderRadius: PropTypes.bool,
	customClassName: PropTypes.string,
};

export default Tag;
